"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../../utils/theme");
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  line-height: 23px;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  line-height: 23px;\n"])), theme_1.colors.grey7);
var templateObject_1;
//# sourceMappingURL=styles.js.map